module.exports = __webpack_public_path__ + "static/img/02.8dc780c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/altcoin/02.png
// module id = HI3N
// module chunks = 0